import BaseInput from 'components/inputs/BaseInput';
import BaseSelect, { SelectOption } from 'components/inputs/BaseSelect';
import React from 'react';
import { MenuPlacement } from 'react-select';
import { ActionMeta, OptionsType, ValueType } from 'react-select/src/types';

interface Props<T = string> {
  id: string;
  className?: string;
  options: SelectOption<T>[];
  value?: SelectOption<T> | null;
  menuPlacement: MenuPlacement;
  onChange: (newSelectedOption: SelectOption<T>) => void;
  placeholder?: string;
  disabled?: boolean;
  label?: string;
}

interface SelectActionHandlers {
  [key: string]: Function;
}

const selectActionHandlers: SelectActionHandlers = {
  'select-option': (
    selectedOption: ValueType<SelectOption, false>
  ): SelectOption | null => {
    if (!selectedOption) {
      return null;
    }

    return selectedOption as SelectOption;
  },

  clear: () => {
    return null;
  },
};

class SingleSelect<T = string> extends React.Component<Props<T>> {
  static defaultProps = {
    options: [],
    menuPlacement: 'auto',
    value: null,
    disabled: false,
  };

  handleChange = (
    selectedOption: SelectOption<T> | OptionsType<SelectOption<T>> | null,
    actionData: ActionMeta<SelectOption<T>>
  ): void => {
    if (selectActionHandlers[actionData.action]) {
      const updatedValue = selectActionHandlers[actionData.action](
        selectedOption,
        actionData
      );

      this.props.onChange(updatedValue);
    }
  };

  render(): React.ReactNode {
    if (this.props.disabled) {
      const { value } = this.props;

      return (
        <BaseInput
          id={`${value ? value.label : ''}-disabled-input`}
          type="text"
          value={value ? value.label : ''}
          name={value ? value.label : ''}
          disabled
        />
      );
    }

    return (
      <BaseSelect<T>
        {...this.props}
        options={this.props.options}
        onChange={this.handleChange}
      />
    );
  }
}

export default SingleSelect;
